import { useAuthRefresh } from "@api/auth";

import Head from "next/head";
import { ReactNode } from "react";

function MainLayout({
  children,
  title,
}: {
  children: ReactNode;
  minimal?: boolean;
  title?: string;
}) {
  useAuthRefresh();

  return (
    <div className="dark:bg-black min-h-screen">
      <Head>
        <title>{title ? `${title} | Helios` : "Helios"}</title>
        <meta name="description" content={`${title} to access the Helios SMS dashboard.`} />
      </Head>

      <main>
        <div className="max-w-7xl pb-36 px-4 sm:pb-36 sm:px-6 sm:py-14 lg:px-8 py-6 mx-auto overflow-x-auto">
          {children}
        </div>
      </main>
    </div>
  );
}

export default MainLayout;
